import React from "react";

export const Search = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M17.9998 18L14.1934 14.1936"
      stroke="#0D0C1C"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M10.8 15.6C13.451 15.6 15.6 13.451 15.6 10.8C15.6 8.14903 13.451 6 10.8 6C8.14903 6 6 8.14903 6 10.8C6 13.451 8.14903 15.6 10.8 15.6Z"
      stroke="#0D0C1C"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
